export default "__VITE_ASSET__BNSv1zYD__"